import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { DelayedDispatchService } from '../../service/delayed-dispatch.service';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { QueryWrapper } from '../../model/query-wrapper.model';
import { SelectItem, ToastMessageOptions } from 'primeng/api';
import { WebSocketService } from '../../service/websocket.service';
import { catchError, EMPTY, takeWhile, timeout } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FILE_UPLOAD_TIMEOUT, generateRandomString } from '../../constant';

@Component({
  selector: 'app-allo-properties',
  templateUrl: './allo-properties.component.html',
  styleUrls: ['./allo-properties.component.css'],
  standalone: false // NOSONAR
})
export class AlloPropertiesComponent implements OnInit {
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  errMsgs: ToastMessageOptions[] = [];
  tblErrMsgs: ToastMessageOptions[] = [];
  propTypes: SelectItem[] = [];
  propType: string;
  propName: string;
  propValue: string;
  alloPropCols: any;
  createdDate: string;
  existingProperties: any;
  filters: any;
  alloSelectedProperty: any[] = [];
  fileUploaded: File;
  storeData: any;
  worksheet: any;
  isValidFileName: boolean;
  domicile: string;
  isFileSelected = false;
  selectedFile: File | null = null;
  selectedFileName: any;
  selectedFilePath: any;


  constructor(private readonly service: DelayedDispatchService,
    private readonly spinnerService: NgxSpinnerService,
    private readonly pipe: DatePipe,
    private readonly webSocketService: WebSocketService,) { }

  ngOnInit() { // NOSONAR
    this.alloPropCols = [
      { field: '', header: 'Select' },
      { field: 'domicile', header: 'Domicile' },
      { field: 'propType', header: 'Type' },
      { field: 'propName', header: 'Name' },
      { field: 'currentPropValue', header: 'Value' },
      { field: 'createdBy', header: 'Created By' },
      { field: 'createdDate', header: 'Created Date' },
      { field: 'updatedBy', header: 'Updated By' },
      { field: 'updatedDate', header: 'Updated Date' }
    ];
    this.getAllProperties();
    this.setPropertyTypes();
  }

  setPropertyTypes() {
    this.propTypes.push(
      { label: "Plant", value: "Plant" },
      { label: "Dock", value: "Dock" },
      { label: "Supplier", value: "Supplier" },
      { label: "Calendar", value: "Calendar" },
      { label: "CrossDock", value: "CrossDock" },
      { label: "PartSupplierDock", value: "PartSupplierDock" },
      { label: "TransporterRate", value: "TransporterRate" },
      { label: "BaselineRoute", value: "BaselineRoute" }
    );
  }

  addProperty() {
    this.validateInput();
    if (this.errMsgs.length == 0) { // NOSONAR
      this.errMsgs = [];
      this.tblErrMsgs = [];
      this.spinnerService.show();
      const qw = new QueryWrapper();
      qw.searchCriteriaMap['propType'] = this.propType;
      qw.searchCriteriaMap['propName'] = this.propName;
      qw.searchCriteriaMap['propValue'] = this.propValue;
      qw.searchCriteriaMap['domicile'] = this.domicile;
      this.service.addAlloProperty(qw).subscribe(
        (data: any) => {
          if (data != null) { // NOSONAR
            this.messageHandler(data);
            this.spinnerService.hide();
          } else {
            this.domicile = '';
            this.propType = '';
            this.propName = '';
            this.propValue = '';
            this.errMsgs = [];
            this.errMsgs.push({ severity: 'success', summary: 'The property has been added successfully!', detail: '' });
            this.getAllProperties();
            this.spinnerService.hide();
          }
        },
        (error: any) => {
          this.errMsgs = [];
          this.errMsgs.push({ severity: 'error', summary: error.message, detail: '' });
          this.spinnerService.hide();
        }
      );
    }
  }

  uploadProperties() {
    this.errMsgs = [];
    this.tblErrMsgs = [];
    this.spinnerService.show();
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.fileUploaded);
    fileReader.onload = (_e) => {
      this.storeData = fileReader.result;
      const data = new Uint8Array(this.storeData);
      const arr = new Array();
      for (let i = 0; i != data.length; ++i) // NOSONAR
        {arr[i] = String.fromCharCode(data[i]);}
      const bstr = arr.join("");
      const workbook = XLSX.read(bstr, { type: "binary" });
      const first_sheet_name = workbook.SheetNames[0];
      this.worksheet = workbook.Sheets[first_sheet_name];
      const formData = new FormData();
      formData.append('file', this.fileUploaded, this.fileUploaded.name);
      // Append userId manually
      const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
      const upn = fgaDetails?.user?.userPrincipalName;
      if (upn) {
        formData.append('userId', upn);
      }
      for (const pair of formData as any) {
        console.info(pair[0], pair[1]);
      }
      this.service.uploadAlloProperties(formData).subscribe(
        (data: any) => {
          if (data != null) { // NOSONAR
            this.messageHandler(data);
            this.spinnerService.hide();
            fileReader = null;
          } else {
            this.fileUploaded = null;
            this.errMsgs = [];
            this.errMsgs.push({ severity: 'success', summary: 'The properties file upload was success!', detail: '' });
            this.getAllProperties();
            this.spinnerService.hide();
            fileReader = null;
          }
        },
        (error: any) => {
          this.errMsgs = [];
          console.info('Upload Error:', error);
          let backendMessage = 'Unexpected error occurred';
          try {
            // error message according to backend
            const messageArray = error?.error?.messages?.[0]?.message;
            if (Array.isArray(messageArray) && messageArray.length > 0) {
              backendMessage = messageArray[0];
            } else if (error?.error?.message) {
              backendMessage = error.error.message;
            } else if (error?.message) {
              backendMessage = error.message;
            }
          } catch (e) {
            console.info('Error parsing backend error:', e);
          }

          this.errMsgs.push({ severity: 'error', summary: backendMessage, detail: '' });
          this.spinnerService.hide();
          fileReader = null;
        }
      );
    }
  }

  exportProperties() {
    this.errMsgs = [];
    this.tblErrMsgs = [];
    this.spinnerService.show();
    const qw = new QueryWrapper();
    this.service.exportAlloProperties(qw).subscribe(
      (response: any) => {
        this.saveToFile(response, "Allo_Properties.xlsx");
        this.setMessage('success', "The existing ALLO properties have been exported successfully.");
        this.spinnerService.hide();
      },
      (error: any) => {
        this.setMessage('error', error.message);
        this.spinnerService.hide();
      }
    );
  }

  updateProperties() {
    this.errMsgs = [];
    this.tblErrMsgs = [];
    this.spinnerService.show();
    const qw = new QueryWrapper();
    qw.alloPropertiesMap['selectedProperties'] = this.alloSelectedProperty;
    this.service.updateAlloProperties(qw).subscribe(
      (data: any) => {
        if (data != null) { // NOSONAR
          this.messageHandler(data);
          this.spinnerService.hide();
          this.alloSelectedProperty = [];
        } else {
          this.alloSelectedProperty = [];
          this.tblErrMsgs = [];
          this.tblErrMsgs.push({ severity: 'success', summary: 'The selected properties have been updated successfully!', detail: '' });
          this.getAllProperties();
          this.spinnerService.hide();
        }
      },
      (error: any) => {
        this.tblErrMsgs = [];
        this.alloSelectedProperty = [];
        this.tblErrMsgs.push({ severity: 'error', summary: error.message, detail: '' });
        this.spinnerService.hide();
      }
    );
  }

  deleteProperties() {
    this.errMsgs = [];
    this.tblErrMsgs = [];
    this.spinnerService.show();
    const qw = new QueryWrapper();
    qw.alloPropertiesMap['selectedProperties'] = this.alloSelectedProperty;
    this.service.deleteAlloProperties(qw).subscribe(
      (data: any) => {
        if (data != null) { // NOSONAR
          this.messageHandler(data);
          this.spinnerService.hide();
          this.alloSelectedProperty = [];
        } else {
          this.alloSelectedProperty = [];
          this.tblErrMsgs = [];
          this.tblErrMsgs.push({ severity: 'success', summary: 'The selected properties have been deleted successfully!', detail: '' });
          this.getAllProperties();
          this.spinnerService.hide();
        }
      },
      (error: any) => {
        this.tblErrMsgs = [];
        this.alloSelectedProperty = [];
        this.tblErrMsgs.push({ severity: 'error', summary: error.message, detail: '' });
        this.spinnerService.hide();
      }
    );
  }

  getAllProperties() {
    this.spinnerService.show();
    this.service.getExistingAlloProperties().subscribe(
      (data: any) => {
        this.existingProperties = data;
        this.spinnerService.hide();
      },
      (error: any) => {
        this.errMsgs = [];
        this.errMsgs.push({ severity: 'error', summary: error.message, detail: '' });
        this.spinnerService.hide();
      }
    );
  }

  validateInput() {
    this.errMsgs = [];
    if (this.domicile == null) { // NOSONAR
      this.errMsgs = [];
      this.errMsgs.push({ severity: 'error', summary: "Domicile is required.", detail: '' });
    } else if (this.domicile.length > 8) {
      this.errMsgs = [];
      this.errMsgs.push({ severity: 'error', summary: "Domicile must not exceed 8 characters.", detail: '' });
    }
    if (this.propType == null) { // NOSONAR
      this.errMsgs = [];
      this.errMsgs.push({ severity: 'error', summary: "Property Type is required.", detail: '' });
    } else if (this.propType.length > 40) {
      this.errMsgs = [];
      this.errMsgs.push({ severity: 'error', summary: "Property Type must not exceed 40 characters.", detail: '' });
    }

    if (this.propName == null) { // NOSONAR
      this.errMsgs = [];
      this.errMsgs.push({ severity: 'error', summary: "Property Name is required.", detail: '' });
    } else if (this.propName.length > 50) {
      this.errMsgs = [];
      this.errMsgs.push({ severity: 'error', summary: "Property Name must not exceed 40 characters.", detail: '' });
    }

    if (this.propValue == null) { // NOSONAR
      this.errMsgs = [];
      this.errMsgs.push({ severity: 'error', summary: "Property Value is required.", detail: '' });
    } else if (this.propValue.length > 30) {
      this.errMsgs = [];
      this.errMsgs.push({ severity: 'error', summary: "Property Value must not exceed 30 characters.", detail: '' });
    }
  }

  onFileSelected(event: Event): void {
    this.errMsgs = [];
    const input = event.target as HTMLInputElement;
    this.isFileSelected = !!input.files && input.files.length > 0;
    if (this.isFileSelected) {
      // Store the file reference
      this.isValidFileName = this.isValidFile(input?.files[0]?.name);
      if (!this.isValidFileName) {
        this.errMsgs.push({ severity: 'error', summary: 'Please upload only XLSX file.', detail: '' });
        return
      }
      const parsedFileName = input?.files[0]?.name
        ?.replace(/\s+/g, '_') // Replace spaces with underscore
        ?.replace(/[^a-zA-Z0-9._]/g, '_'); // Replace all non-alphanumeric/safe characters with underscore
      this.selectedFileName = `${generateRandomString()}_${parsedFileName}`;
      this.selectedFilePath = `ALLO/PROPERTIES/${this.selectedFileName}`;
      this.selectedFile = input.files[0];
    }
  }

  onFileChanged(event) {
    this.errMsgs = [];
    this.fileUploaded = event.target.files[0];
    this.isValidFileName = this.isValidFile(this.fileUploaded.name);
    if (!this.isValidFileName) {
      this.errMsgs.push({ severity: 'error', summary: 'Please upload only XLSX file.', detail: '' });
    }
  }

  isValidFile(name: String) {
    const ext = name.substr(name.lastIndexOf('.') + 1);
    if (ext.toLowerCase() == 'xlsx') { // NOSONAR
      return true;
    } else {
      return false;
    }
  }

  messageHandler(data) {
    this.messageHandlerType(data, 'error');
  }

  messageHandlerType(data, type) {
    this.errMsgs = [];
    if (data.messages != undefined && data.messages.length != 0) { // NOSONAR
      for (const entry of data.messages) {
        for (const mes of entry.message.sort()) {
          this.setMessage(type, mes);
        }
      }
      return;
    } else {
      this.existingProperties = data;
    }
  }

  setMessage(type, desc) {
    this.errMsgs.push({ severity: type, summary: desc, detail: '' });
  }

  filterCapture(_event, data) {
    this.filters = data.filters;
  }

  formatDate(dt) {
    return this.pipe.transform(dt, 'MM/dd/yyyy', 'EST');
  }

  saveToFile(response, fileName) {
    saveAs(response, fileName);
  }



  async uploadFile() {




    this.spinnerService.show();
    try {
      this.webSocketService.connect();
      await this.webSocketService.waitUntilSocketConnected();
      console.info(
        'WebSocket connected:',
        this.webSocketService.isSocketConnected()
      );
      this.webSocketService.sendMessage(
        // JSON.stringify({
        { fileName: this.selectedFilePath }
        // })
      );
      const url = `${environment.FILE_UPLOAD_URI}/${this.selectedFilePath}`;
      const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
      const upn = fgaDetails?.user?.userPrincipalName;

      const uploadHeaders: any = {
        'Content-Type': this.selectedFile?.type, // Set file content type
        'x-amz-meta-authtoken': sessionStorage.getItem('accessToken'),
        'x-amz-meta-userid': upn,
        'x-auth-token': sessionStorage.getItem('accessToken')

      };

      const response = await fetch(url, {
        method: 'PUT',
        headers: uploadHeaders,
        body: this.selectedFile,
      });

      if (!response.ok) {
        this.spinnerService.hide();; // 🛑 Stop spinner on error
        this.errMsgs.push({ severity: 'error', summary: 'Failed to upload file!', detail: '' });
        this.webSocketService.closeConnection();
        return;
      }

      this.webSocketService
        .receiveMessages()
        .pipe(
          // If no message is received within 25 seconds, throw TimeoutError
          timeout({
            each: FILE_UPLOAD_TIMEOUT, // 25 seconds between messages
          }),
          takeWhile( (msg) => msg.status != 'success' && msg.status != 'failed' && msg.status != 'error', true ), // NOSONAR
          catchError((err) => {
            if (err.name == 'TimeoutError') { // NOSONAR
              console.info(
                `No message received in ${FILE_UPLOAD_TIMEOUT / 1000
                } seconds. Closing connection.`
              );
              this.spinnerService.hide();;
              this.webSocketService.closeConnection();
              this.errMsgs.push({ severity: 'error', summary: 'Failed to upload file. Please re-upload the file.', detail: '' });

            } else {
              console.info('WebSocket error:', err);
            }
            return EMPTY; // Stop further emissions
          })
        )
        .subscribe((messages) => {
          console.info(messages, "messages from Lambda");

          const backendResp = messages.backendResponse;
          try {
            if (backendResp) {
              // Check backend API response for success/failure
              if (backendResp.messages?.length == 0) { // NOSONAR
                // Success
                this.spinnerService.hide();
                this.errMsgs = [];
                this.errMsgs.push({
                  severity: 'success',
                  summary: 'The properties file upload was success!',
                  detail: '',
                });
              } else {
                // Failure
                this.spinnerService.hide();
                this.errMsgs.push({
                  severity: 'error',
                  summary: backendResp.messages.map((m: any) => m.message).join(', '),
                  detail: '',
                });
              }

              this.fileInput.nativeElement.value = '';

              this.selectedFile = null;
              this.isFileSelected = false;
              this.getAllProperties();
              this.webSocketService.closeConnection();
            }
          }
          catch {
            this.spinnerService.hide();;
            this.webSocketService.closeConnection();
            this.errMsgs.push({ severity: 'error', summary: 'An unexpected error occurred. Please retry. Contact IS Service Desk if error persists', detail: '' });
            this.fileInput.nativeElement.value = '';
            this.selectedFile = null;
            this.isFileSelected = false;
          }


          
        })
    } catch (err) {
      console.info('Unexpected upload exception:', err);
      this.spinnerService.hide();;
      this.webSocketService.closeConnection();
      this.errMsgs.push({ severity: 'error', summary: 'An unexpected error occurred. Please retry. Contact IS Service Desk if error persists', detail: '' });
      this.fileInput.nativeElement.value = '';
      this.selectedFile = null;
      this.isFileSelected = false;
    }
  }

  downloadErrorFile(filePath: string) {
    if (!filePath) {
      console.info('File path is empty');
      return;
    }
    const fullUrl = `${environment.FILE_UPLOAD_URI}/${filePath}`;
    const anchor = document.createElement('a');
    anchor.href = fullUrl;
    anchor.download = filePath.split('/').pop() || 'downloaded_file'; // Extracts filename dynamically
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor); // NOSONAR
  }
}

